import { FC, ReactElement, useMemo } from 'react';
import { ShortCode } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import Picker from '~/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import './style.scss';

interface IProps {
  onSelectOptions: (options: IPickerOption[]) => void;
}

const KioskConfigShortCodePicker: FC<IProps> = (props: IProps): ReactElement => {
  const selectedOption = useMemo((): IPickerOption[] => {
    return [{ value: 'add_placeholders', label: localeStore.t('add_placeholders') }];
  }, []);

  const options = useMemo((): IPickerOption[] => {
    return [
      { value: ShortCode.ORDER_NUMBER, label: localeStore.t('order_number_1') },
      { value: ShortCode.APP_LINK, label: localeStore.t('app_link') },
      { value: ShortCode.SMS_ORDER_LINK, label: localeStore.t('sms_link') },
    ];
  }, []);

  return (
    <div className="kiosk-config-short-code-picker__wrapper">
      <p className="kiosk-config-short-code-picker__title">{localeStore.t('purpose_of_message')}</p>
      <Picker selectedOptions={selectedOption} options={options} onSelect={props.onSelectOptions} noReset />
    </div>
  );
};

export default KioskConfigShortCodePicker;
